import React from 'react';

import { Form } from 'react-bootstrap';

import ActivitySourceOptions from '../ActivityMetaFields/ActivitySourceOptions';
import {
  ActivitySource,
  ActivitySourceValue,
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  StripeSourceMetadata,
  ExternalSourceMetadata,
} from '../../../types/Activity';
import { StripeAccount } from '../../../types/Stripe';
import { hasNoBookingPlatformIntegration } from '../../forms/EditPeekAndRedeamOrderForm/helpers';
import Disable from '../../utils/Disable';

import { ConnectStripeAccountForm } from './ConnectStripeAccountForm';
import { isConnectedStripeAccount } from './helpers';

type Props = {
  commission: number;
  deadline: string | undefined | number;
  metadata: ExternalSourceMetadata | StripeSourceMetadata | undefined;
  onChange(prop: string, value): void;
  showErrors: boolean;
  source: ActivitySource | undefined;
  stripeAccounts: StripeAccount[];
  existingSource?: ActivitySourceValue;
  disabled: boolean;
};

// eslint-disable-next-line import/no-unused-modules
export const ActivitiesSourceForm = ({
  commission,
  metadata,
  onChange,
  showErrors,
  source,
  stripeAccounts,
  existingSource,
  deadline,
  disabled,
}: Props) => {
  const onSourceChange = value => {
    onChange('source', value);
    onChange('metadata', { ...metadata, stripeId: undefined });
    if (!hasNoBookingPlatformIntegration(value)) {
      onChange('deadline', 0);
    } else if (typeof deadline === 'undefined' || Number(deadline) === 0) {
      onChange('deadline', undefined);
    }
  };
  return (
    <Disable disabled={disabled}>
      <Form>
        <ActivitySourceOptions
          label='Source'
          initialValue={source}
          existingSource={existingSource}
          onMetaFieldsChange={onSourceChange}
          display='block'
        />
        {isConnectedStripeAccount(source) && (
          <ConnectStripeAccountForm
            stripeAccounts={stripeAccounts}
            initialCommission={commission}
            source={source as ActivitySourceValue}
            metadata={metadata as StripeSourceMetadata}
            onChange={onChange}
            showErrors={showErrors}
          />
        )}
      </Form>
    </Disable>
  );
};
